import { inject, Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
export interface ListData {
  catChip: number;
  catId: string;
  catName: string;
  catSex: string;
  catTnr: number;
  catType: string;
  imgFile: string;
  catContent: null;
}
export interface GetListResponse {
  RequestURL: 'getAllCat';
  catGet: number;
  catQty: number;
  catInPage: string;
  pageIdx: string;
  catInfoObj: { catObj: ListData }[];
}

interface GetListRequest {
  [key: string]: string;
  catSort: string;
  pageidx: string;
  catInPage: string;
}

@Injectable({
  providedIn: 'root',
})
export class GetListService {
  private baseApiService = inject(BaseApiService);

  getListApi(url: string, req: GetListRequest) {
    return this.baseApiService.basePost<GetListRequest, GetListResponse>(
      url,
      req
    );
  }
}
